<template>
    <div class="update-report-dialog">
        <el-dialog
            :title="`${$t('Stats.Update.title')}${title}${$t('Stats.Update.table')}`"
            :visible.sync="visible">
            <el-form
                ref="form"
                :model="form"
                :status-icon="true"
                label-width="100px"
                label-suffix=" : "
                label-position="right"
                v-loading="loading">
                <el-form-item :label="$t('Stats.Update.store')">
                    <el-select v-model="form.storeId" :placeholder="$t('Common.all_store2')">
                        <el-option
                            v-for="item in stores"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Stats.Update.time')">
                    <el-date-picker
                        v-model="date"
                        :clearable="false"
                        type="daterange"
                        range-separator="-"
                        :start-placeholder="$t('Common.start_time')"
                        :end-placeholder="$t('Common.end_time')" />
                </el-form-item>
            </el-form>
            <div class="update-report-footer">
                <el-button type="primary" @click="onSubmit">
                    {{ $t('Stats.Update.confirm') }}
                </el-button>
                <div class="mt-8 footer-tips">{{ $t('Stats.Update.ps') }}</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {Dialog, DatePicker} from 'element-ui';

    export default {
        name: 'UpdateReport',
        components: {
            ElDialog: Dialog,
            ElDatePicker: DatePicker,
        },
        props: [],
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                date: [new Date(), new Date()],
                stores: [],
                form: {
                    type: '',
                    storeId: '',
                },
            };
        },
        computed: {
        },
        watch: {
            visible(val) {
                if (!val) {
                    this.$refs.form.clearValidate();
                    this.form = {
                        type: '',
                        storeId: '',
                    };
                    this.date = [new Date(), new Date()];
                }
            }
        },
        methods: {
            open(form, title) {
                this.form = {...this.form, ...form};
                this.title = title;
                this.visible = true;
            },
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (!valid) return;
                    this.postData();
                });
            },
            async postData() {
                this.loading = true;
                try {
                    if (this.date.length) {
                        this.form.dateFrom = new Date(this.date[0]).format('YYYY-MM-DD');
                        this.form.dateTo = new Date(this.date[1]).format('YYYY-MM-DD');
                    } else {
                        this.form.dateFrom = null;
                        this.form.dateTo = null;
                    }
                    await API.post('statistic/refresh', this.form);

                    $ele.$message.success(this.$t('Stats.Update.message'));
                    this.loading = false;
                    this.visible = false;
                    this.$emit('emitData', true);
                } catch (err) {
                    this.loading = false;
                }
            },
            fetchStore() {
                API.get('store/list').then(res => {
                    this.stores = res;
                    this.stores.unshift({
                        id: '',
                        name: this.$t('Common.all_store2'),
                    })
                });
            },
        },
        created() {
            this.fetchStore();
        }
    };
</script>

<style lang="scss">
.update-report-dialog {
    .el-dialog {
        width: 710px;
    }
}
.update-report-footer {
    margin-left: 100px;
}
.footer-tips {
    font-size: 12px;
}
</style>
